/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TurJobExecution } from '../../models/tur-job-execution';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetJobExecutions$Params {
  jobId: string;
  index: number;
  count: number;
}

export function getJobExecutions(
  http: HttpClient,
  rootUrl: string,
  params: GetJobExecutions$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<TurJobExecution>>> {
  const rb = new RequestBuilder(rootUrl, getJobExecutions.PATH, 'get');
  if (params) {
    rb.path('jobId', params.jobId, {});
    rb.path('index', params.index, {});
    rb.path('count', params.count, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TurJobExecution>>;
    }),
  );
}

getJobExecutions.PATH = '/manage/job/{jobId}/executions/{index}/{count}';
